import { gql } from '@apollo/client'

export default gql`
  mutation addSectionToProject($id: ID!, $sectionId: ID!) {
    addSectionToProject(id: $id, sectionId: $sectionId) {
      id
      name
      sections {
        id
        name
      }
    }
  }
`
